import { type AxiosInstance } from 'axios';

import { type roles } from '@terra/contracts';

export function rolesEndpoints(api: AxiosInstance) {
  return {
    listAdminRoles: async () => {
      const { data } = await api.get<roles.AdminRoleResponse[]>('/roles');
      return data;
    },
    createAdminRole: async (input: roles.CreateAdminRoleRequest) => {
      const { data } = await api.post<roles.AdminRoleResponse>('/roles', input);
      return data;
    },
    updateAdminRole: async (roleId: string, input: roles.UpdateAdminRoleRequest) => {
      const { data } = await api.patch<roles.AdminRoleResponse>(`/roles/${roleId}`, input);
      return data;
    },
    deleteAdminRole: async (roleId: string) => {
      await api.delete(`/roles/${roleId}`);
    },
  };
}

export type RoleEndpoints = ReturnType<typeof rolesEndpoints>;
